import { useTranslations } from './useTranslations';
import { useTranslation as useTranslationI18n } from 'react-i18next';

function removeSecondLastChunk(str: string) {
	const parts = str.split('.');
	if (parts.length <= 1) return str;
	if (parts.length === 2) return parts[1];
	parts.splice(parts.length - 2, 1);
	return parts.join('.');
}

export function useLocalizationLabel(): { t: (key: string) => string; tRecursive: (key: string) => string; exists: (key: string) => boolean } {
	const { isLoading } = useTranslations('en');
	const { t, i18n } = useTranslationI18n();

	if (isLoading) {
		const fallbackT = ((key: string) => key) as typeof t;
		return { t: fallbackT, tRecursive: fallbackT, exists: () => false };
	}

	const nonRecursiveTranslation = (key: string) => {
		if (!i18n.exists(key.toUpperCase())) {
			//console.warn(`Translation key "${key.toUpperCase()}" does not exist.`);
			return key;
		}
		return t(key.toUpperCase());
	};

	const recursiveTranslation = (key: string): string => {
		let translationKey = key;
		while (!i18n.exists(translationKey.toUpperCase())) {
			const keyParts = translationKey.split('.');
			if (keyParts.length === 1) {
				//console.warn(`Translation key "${key.toUpperCase()}" does not exist.`);
				return key;
			}
			translationKey = removeSecondLastChunk(translationKey);
		}
		return t(translationKey.toUpperCase());
	};

	const upperCaseExists = (key: string) => {
		return i18n.exists(key.toUpperCase());
	};

	return { t: nonRecursiveTranslation, tRecursive: recursiveTranslation, exists: upperCaseExists };
}
